(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/models/super/entry.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/models/super/entry.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  const trinidad = svs.core;
  svs.tur.start_subscription.models.Entry = Backbone.Model.extend({
    CONSTANTS: svs.tur.start_subscription.constants,
    defaults() {
      return {
        subscriptionId: undefined,
        entry: undefined,
        isAutogiro: false,
        isBankcard: false,
        hasActivePayChannel: false,
        amount: undefined,
        paymentTypeText: undefined,
        payTime: undefined,
        startTime: undefined,
        stopTime: undefined,
        newSubId: undefined,
        firstAndLastName: undefined,
        personalId: undefined,
        bankAccountNumber: undefined,
        clearingNumber: undefined,
        accountNumber: undefined,
        bankName: undefined,
        cancelUrl: undefined,
        isNewSubOnlyBankcard: false
      };
    },
    parseAutogiroInfo(data) {
      const autogiroData = {};
      let bankAccounts;
      for (let i = 0; i < data.responses.length; i++) {
        const response = data.responses[i].response;
        if (response.personalId) {
          autogiroData.personalId = response.personalId;
          autogiroData.firstAndLastName = "".concat(response.firstName, " ").concat(response.lastName);
        }
        if (response.bankAccounts) {
          bankAccounts = response.bankAccounts[0];
          autogiroData.accountNumber = bankAccounts.accountNumber;
          autogiroData.clearingNumber = bankAccounts.clearingNumber;
          autogiroData.bankAccountNumber = autogiroData.clearingNumber + autogiroData.accountNumber;
          autogiroData.bankName = bankAccounts.bankName;
        }
        if (response.playerProperties) {
          autogiroData.customerId = response.playerProperties.customerId;
        }
      }
      return autogiroData;
    },
    getAutogiroInfo(options) {
      options = options || {};

      const model = this;
      const context = options.context;
      const successCallback = options.success;
      const version = svs.core.detect.feature('ft-its-api-version') ? '3' : '2';

      options.success = async function () {
        try {
          const urls = ["/player/".concat(version, "/info"), '/player/1/bankaccounts', '/player/1/properties?propertyList=customerId'];
          const promises = urls.map(url => trinidad.jupiter.callAsync({
            method: 'GET',
            path: url,
            req: options.req
          }));
          const responses = await Promise.all(promises);

          const data = {
            responses
          };

          const attr = model.parseAutogiroInfo(data);
          model.set(attr);
          svs.components.loader.hide();
          if (successCallback) {
            successCallback.call(context, model, data, options);
          }
        } catch (error) {
          model.parseError(error);
        }
      };
      options.error = model.parseError;

      options.attrs = {};

      options.url = "".concat(svs.core.jupiter.url(), "/player/").concat(version, "/info");
      svs.components.loader.show();
      this.sync('read', this, options);
    },
    parseError(xhr) {
      svs.tur.start_subscription.radio.trigger('handleError', xhr);
    },
    reset() {
      this.clear({
        silent: true
      });
    }
  });
})(Backbone, _, svs);

 })(window);